import React from 'react';
import { Container } from './styles';

// import smileImage from '~/assets/tv/november-2025/7.jpg';
import smileImage from '~/assets/tv/change-your-smile/TV7.png'; // TODO: placeholder, trocar pela imagem de novembro

interface IChangeYourSmile7Props {
  show: boolean;
  startAnim: boolean;
}

const ChangeYourSmile7: React.FC<IChangeYourSmile7Props> = ({
  show,
  startAnim,
}) => {
  return (
    <Container show={show} startAnim={startAnim}>
      <img className="bg" src={smileImage} alt="chega de esconder o Sorriso" />
    </Container>
  );
};

export default ChangeYourSmile7;
